import { render, staticRenderFns } from "./NewBatchView.vue?vue&type=template&id=5c2352ba&scoped=true"
import script from "./NewBatchView.vue?vue&type=script&lang=js"
export * from "./NewBatchView.vue?vue&type=script&lang=js"
import style0 from "./NewBatchView.vue?vue&type=style&index=0&id=5c2352ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2352ba",
  null
  
)

export default component.exports